import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePageVisibility } from '../contexts/PageVisibilityContext';
function ProtectedRoute() {
    const { user, isAuthenticated, isLoading } = useAuth();
    const { canViewLocation } = usePageVisibility();
    const location = useLocation();
    if (isLoading) {
        return (_jsx("div", { style: { display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center' }, children: "Loading..." }));
    }
    if (!isAuthenticated) {
        return _jsx(Navigate, { to: "/login", state: { from: location }, replace: true });
    }
    // Accounts created with a shared temporary password (e.g. the onboarding
    // bulk-import) must set a real one before touching anything else.
    if (user?.mustChangePassword && location.pathname !== '/force-change-password') {
        return _jsx(Navigate, { to: "/force-change-password", replace: true });
    }
    if (location.pathname !== '/profile' && !canViewLocation(location.pathname, location.search)) {
        return _jsx(Navigate, { to: "/profile", replace: true });
    }
    return _jsx(Outlet, {});
}
export default ProtectedRoute;
